export const Headeroptions = [
  { heading: 'Profile', path: '/listeners/profile' },
  { heading: 'Engagement', path: '/listeners/engagement' },
  { heading: 'Connections', path: '/listeners/connection' },
  { heading: 'Availability', path: '/listeners/availabilty' },
  { heading: 'Audio', path: '/listeners/audio' },
  { heading: 'Video', path: '/listeners/video' },
  { heading: 'Payout', path: '/listeners/payout' },
  { heading: 'Log', path: '/listeners/log' },
  { heading: 'On Call', path: '/listeners/oncall' },
];

export const PeerHeaderoptions = [
  { heading: 'Profile', path: '/peers/profile' },
  { heading: 'Engagement', path: '/peers/engagement' },
  { heading: 'Audio', path: '/peers/audio' },
  { heading: 'Video', path: '/peers/video' },
  { heading: 'Payout', path: '/peers/payout' },
];

export const weeks = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const listenerTypes = {
  All: 'All',
  Active: 'peerlistener,peer',
  'Peer Listeners': 'peerlistener',
  Peers: 'peer,onboardingpeer',
};

export const listenerFilters = [
  { name: 'Not Visible', code: { active_peers: false } },
  { name: 'Active', code: { active_peers: true } },
  { name: 'All', code: {} },
];
